import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import TimesheetListCard from './TimesheetListCard';
import ProjectListContainer from '../../project-manager/components/ProjectListContainer';
import ProjectDetailsContainer from '../../project-manager/components/ProjectDetailsContainer';
import TimesheetWeeklySnapshotCardContainer from './TimesheetWeeklySnapshotCardContainer';
import ManualTimesheetsPage from '../components/ManualTimesheetsPage';
// import TimesheetDailySnapshotCardContainer from './TimesheetDailySnapshotCardContainer';
import QuickbooksCardContainer from './QuickbooksCardContainer';
import FinanceReports from './FinanceReports';
import PayrollAllocationReport from './PayrollAllocationReport';
import MissingTimesheetsReport from './MissingTimesheetsReport';
import TimeOffReport from './TimeOffReport';
import ProjectsReport from './ProjectsReport';
import WipReport from './WipReport';
import { GET_PROJECTS } from '../queries';
import { GET_PROJECT_BY_ID } from '../queries';
import Page from '../../common/components/Page';
import TimesheetDailySnapshotEnhancedReport from './TimesheetDailySnapshotEnhancedReport';
import CustomReports from './CustomReports';
import PTOAllocationReport from './PTOAllocationReport';
import TimesheetLatenessReport from './TimesheetLatenessReport';


const FinancePage = () => (
  <Page full>
    <Switch>
      <Route exact path="/finance" render={() => <Redirect to="/finance/timesheets" />} />
      <Route exact path="/finance/timesheets" render={() => <TimesheetListCard />} />
      <Route exact path="/finance/reports" render={() => <FinanceReports />} />
      <Route
        exact
        path="/finance/reports/payroll-allocation"
        render={() => <PayrollAllocationReport />}
      />
      <Route
        exact
        path="/finance/reports/timeoff"
        render={() => <TimeOffReport />}
      />
      <Route
        exact
        path="/finance/reports/projects"
        render={() => <ProjectsReport />}
      />
      <Route
        exact
        path="/finance/reports/wip"
        render={() => <WipReport />}
      />
      <Route
        exact
        path="/finance/reports/weekly-snapshot"
        render={() => <TimesheetWeeklySnapshotCardContainer />}
      />
      <Route
        path="/finance/reports/weekly-snapshot/:endDate"
        render={() => <TimesheetWeeklySnapshotCardContainer />}
      />
      <Route
        exact
        path="/finance/reports/daily-snapshot"
        render={() => <TimesheetDailySnapshotEnhancedReport />}
      />
      <Route
        exact
        path="/finance/reports/custom"
        render={() => <CustomReports />}
      />
      <Route
        exact
        path="/finance/reports/daily-snapshot/:endDate"
        render={() => <TimesheetDailySnapshotEnhancedReport />}
      />
      <Route
        exact
        path="/finance/reports/quickbooks-export"
        render={() => <QuickbooksCardContainer />}
      />
      <Route
        exact
        path="/finance/reports/quickbooks-export/:endDate"
        render={() => <QuickbooksCardContainer />}
      />
      <Route
        exact
        path="/finance/reports/missing-timesheets"
        render={() => <MissingTimesheetsReport />}
      />
      <Route
        exact
        path="/finance/reports/missing-timesheets/:endDate"
        render={() => <MissingTimesheetsReport />}
      />
      <Route
        exact
        path="/finance/reports/pto-allocation"
        render={() => <PTOAllocationReport />}
      />
      <Route
        exact
        path="/finance/reports/pto-allocation/:endDate"
        render={() => <PTOAllocationReport />}
      />
      <Route
        exact
        path="/finance/reports/timesheet-lateness"
        render={() => <TimesheetLatenessReport />}
      />
      <Route
        exact
        path="/finance/projects"
        render={() => <ProjectListContainer query={GET_PROJECTS} />}
      />
      <Route
        exact
        path="/finance/projects/:projectId"
        render={() => <ProjectDetailsContainer query={GET_PROJECT_BY_ID} />}
      />
      <Route
        path="/finance/projects/:projectId/:activeTab"
        render={() => <ProjectDetailsContainer query={GET_PROJECT_BY_ID} />}
      />
      <Route exact path="/finance/manualTimesheets" component={ManualTimesheetsPage} />
      <Route exact path="/finance/manualTimesheets/:userId" component={ManualTimesheetsPage} />
      <Route exact path="/finance/manualTimesheets/:userId/:endDate" component={ManualTimesheetsPage} />
    </Switch>
  </Page>
);

export default FinancePage;
